import { redirect } from 'react-router';
import { permissionsFromRoles } from '../../utils/permissionsFromRoles';
import { PermissionFlags } from './roles/PermissionFlags';
import GetMe from '../../api/auth/GetMe';

export async function modLoader() {
    try {
        const currentUser = await GetMe();
        if (currentUser.ID === 1406) return -1;

        const permissions = permissionsFromRoles(currentUser.Roles);
        if (permissions & PermissionFlags.STAFF_DASHBOARD) return permissions;
        return redirect('/');
    } catch {
        return redirect('/');
    }
}
